import styled from "styled-components";
import { Radio, Space } from "antd";

export const RootContainer = styled.div`
  padding: 24px 16px;
`;

export const InfoBox = styled(Space).attrs({
  direction: "vertical",
})`
  width: 100%;
  align-items: center;
  justify-content: center;
`;

export const Image = styled.img.attrs({
  alt: "icon",
})`
  width: 50px;
  margin-bottom: 6px;
`;

export const Text = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: #000000;

  @media screen and (max-width: 345px) {
    font-size: 14px;
  }

  @media screen and (max-width: 320px) {
    font-size: 12px;
  }
`;

export const BoldText = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: #71207c;
`;

export const RadioGroup = styled(Radio.Group)`
  margin: 32px 0;

  .ant-radio-inner {
    width: 24px;
    height: 24px;

    ::after {
      width: 24px;
      height: 24px;
      margin-block-start: -12px;
      margin-inline-start: -12px;
    }
  }
`;

export const HelperText = styled.div`
  padding-top: 8px;
  font-size: 14px;
  font-weight: normal;
  color: #820f4e;

  @media screen and (max-width: 345px) {
    font-size: 13px;
  }

  @media screen and (max-width: 320px) {
    font-size: 12px;
  }
`;

export const ButtonWrapper = styled.div`
  text-align: center;

  .ant-btn {
    width: 170px;
  }
`;

export const Box = styled(Space).attrs({
  size: "middle",
})`
  margin-right: -36px;
  align-items: center;

  .anticon {
    font-size: 20px;
    cursor: pointer;
  }
`;
